import React from "react";
import { Box, Typography } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";

const Contact = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #111, #222)",
        color: "#fff",
        py: 10,
        px: { xs: 3, md: 8 },
        textAlign: "center",
      }}
    >
      <Typography
        variant="h3"
        fontWeight="bold"
        sx={{
          mb: 2,
          color: "rgb(198, 40, 40)",
          fontSize: { xs: "2.2rem", md: "3rem" },
        }}
      >
        Contact Us
      </Typography>

      <Typography variant="body1" sx={{ color: "#bbb", mb: 4 }}>
        Reach out to us using the details below!
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{
            color: "#fff",
            mb: 2,
            letterSpacing: "0.5px",
            textAlign: "center",
          }}
        >
          Sujan Chowdary
        </Typography>

        {/* Center-aligned details */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.8,
          }}
        >
          <Typography
            variant="body1"
            sx={{ display: "flex", alignItems: "center", color: "#aaa" }}
          >
            <MailOutlineIcon sx={{ fontSize: 20, mr: 1 }} />
            sujanchowdaryk@gmail.com
          </Typography>

          <Typography
            variant="body1"
            sx={{ display: "flex", alignItems: "center", color: "#aaa" }}
          >
            <PhoneIcon sx={{ fontSize: 20, mr: 1 }} />
            +91 9902204503
          </Typography>
        </Box>
      </Box>

      {/* Google Map Embed */}
      <Box
        sx={{
          mt: 4,
          borderRadius: "12px",
          overflow: "hidden",
          mx: "auto",
          boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
        }}
      >
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.752886969619!2d77.70293977623147!3d12.987650987329197!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae11f9478ec975%3A0xac4045da7e22b710!2sThird%20Axis!5e0!3m2!1sen!2sin!4v1757066035131!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </Box>
    </Box>
  );
};

export default Contact;
